module.exports = __webpack_public_path__ + "img/42000.ce01fe2c.jpg";